import React from "react";
import styles from "./index.module.scss";

interface FieldErrorProps {
    error?: string[];
}

export default function FieldError({ error }: FieldErrorProps) {
    if (!error) return null;
    return <div className={styles.root}>{error[0]}</div>;
}
